import { FormattedMessage } from "react-intl";
import { cloneElement } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { DefaultUserMenu } from "@rio-cloud/rio-user-menu-component";
import { RioNotifications } from "@rio-cloud/rio-notifications-component";
import ApplicationHeader from "@rio-cloud/rio-uikit/ApplicationHeader";
import IframeResizer from "iframe-resizer-react";
import { config } from "../../config";
import ServiceInfo from "./ServiceInfo";
import { useIntl } from "react-intl";

interface IAppHeaderProps {
  navItems: { key: string; value: string }[];
}

const AppHeader = ({ navItems }: IAppHeaderProps) => {
  const intl = useIntl();

  const environment = import.meta.env.PROD ? "production" : "local";
  const location = useLocation();

  const serviceInfoItem = cloneElement(<ServiceInfo />, {
    id: "rio-action-serviceInfo",
    "data-rio-action": "serviceInfo",
  });
  const notifications = (
    <div id="rio-action-platformNotifications" data-rio-action="platformNotifications">
      <RioNotifications />
    </div>
  );
  const userMenuItem = (
    <div id="rio-action-userMenu" data-rio-action="userMenu">
      <DefaultUserMenu environment={environment} />
    </div>
  );

  const getLabel = () => {
    if (location.pathname.startsWith('/backoffice')) {
      return "UPTIME - BACKOFFICE";
    }
    return (
      <div className="relative w-[100%] h-[50px]">
        <div className="absolute top-0 left-0">
          {intl.formatMessage({ id: "intl-msg:starterTemplate.moduleName" })}
        </div>
        <div className="logo" />
      </div>
    )
  };

  return (
    <ApplicationHeader
      label={getLabel()}
      appNavigator={
        <IframeResizer
          className="iFrameResizer"
          src={config.backend.MENU_SERVICE}
        />
      }
      navItems={navItems.map((item) => ({
        key: item.key,
        route: <NavLink to={`/${item.key}`}>{item.value}</NavLink>,
      }))}
      homeRoute={<Link to={config.homeRoute || ""} />}
      actionBarItems={[serviceInfoItem, notifications, userMenuItem]}
    />
  );
};

export default AppHeader;
